import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useModuloInfo } from "../../../../../Context/ModuloInfo";
import {
    ListarDocumentoTemplatePorClassificacaoController,
    PreencherTemplateEmailClienteController,
} from "../../../../../Controllers/Geral/Documentos/DocumentosController";
import { EnviarEmailController } from "../../../../../Controllers/Geral/Email/EmailController";
import { ListarEmailContaController } from "../../../../../Controllers/Geral/GestaoDeCadastros/EmailConta/EmailContaController";
import { ListarUsuariosController } from "../../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { PreencherLinkEmailAgendamentoClienteVistoriaController } from "../../../../../Controllers/Vistorias/GestaoDeVistorias/GestaoDeVistoriasControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { IEnviarEmail } from "../../../../../Interfaces/Geral/Email/EmailInterface";
import UnForm from "../../../../Form";
import { FroalaEditor } from "../../../Forms/Editor/FroalaEditor";

interface htmlQuill {
    editorHtml: string;
}

interface IAgendamentoPeloCliente {
    setShow: Dispatch<SetStateAction<boolean>>;
}

export default function AgendamentoPeloCliente(props: IAgendamentoPeloCliente) {
    const { id } = useModuloInfo();
    const { ID_CASO, Atendimento } = useAtendimentoPage();
    const FormMethods = useForm();
    const { watch } = FormMethods;
    const watcher = watch();

    const { execute: EnviarEmail, loading: EnviarEmailLoading } =
        useAsyncCallback(EnviarEmailController);

    const [convertedText, setConvertedText] = useState<htmlQuill>({
        editorHtml: "",
    } as htmlQuill);
    const [idUsuarioTecnico, setIdUsuarioTecnico] = useState(0);
    const [emailDestinatario, setEmailDestinatario] = useState<string>();

    function handleChange(html: string) {
        setConvertedText({ editorHtml: html });
    }

    const { value: LstDocumentoTemplate } = useAsyncEffect(
        () =>
            ListarDocumentoTemplatePorClassificacaoController(id ?? 0, 7, true),
        [id]
    );

    const {
        execute: PreencherLinkEmailAgendamentoClienteVistoria,
        loading: PreencherLinkEmailAgendamentoClienteVistoriaLoading,
    } = useAsyncCallback(
        PreencherLinkEmailAgendamentoClienteVistoriaController
    );

    function handleEnviarEmailAgendamentoCliente(formData: IEnviarEmail) {
        PreencherLinkEmailAgendamentoClienteVistoria(
            idUsuarioTecnico,
            ID_CASO,
            formData.DS_ASSUNTO,
            convertedText.editorHtml ? String(convertedText.editorHtml) : ""
        ).then((res) => {
            EnviarEmail({
                ...formData,
                ID_CASO: ID_CASO,
                DS_DESTINATARIO: emailDestinatario ?? "",
                DS_MENSAGEM: res,
            }).then(() => {
                props.setShow(false);
            });
        });
    }

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                handleSubmit={handleEnviarEmailAgendamentoCliente}
                usingContext
            >
                {({ getValues, setValue }) => (
                    <>
                        <div className="row m-0">
                            <div className="col-md-4 mb-2">
                                <UnForm.LazySelect
                                    name="ID_USUARIO"
                                    label="Atribuído a"
                                    controller={ListarUsuariosController}
                                    getDS={(ds) => ds.DS_NOME}
                                    getKeyValue={(key) => key.ID_USUARIO}
                                    onChange={(e) =>
                                        setIdUsuarioTecnico(
                                            Number(e.target.value)
                                        )
                                    }
                                    registerOptions={{
                                        required:
                                            "Insira o técnico responsável",
                                    }}
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                            <div className="col-md-4 mb-2">
                                <label>Email Remetente:</label>
                                <UnForm.LazySelect
                                    name="ID_REMETENTE"
                                    controller={ListarEmailContaController}
                                    getDS={(ds) => ds.DS_REMETENTE}
                                    getKeyValue={(key) => key.ID_EMAIL_CONTA}
                                    placeholder={"Digite o email"}
                                    registerOptions={{
                                        required: "Insira o email do remetente",
                                    }}
                                >
                                    <option value={0}></option>
                                </UnForm.LazySelect>
                            </div>
                            <div className="col-md-4 mb-2">
                                <label>Email Destinatário:</label>
                                <UnForm.Input
                                    type={"email"}
                                    name="DS_DESTINATARIO"
                                    onChange={(e) => {
                                        setEmailDestinatario(e.target.value);
                                    }}
                                    registerOptions={{
                                        required:
                                            "Insira o email do destinatário",
                                    }}
                                />
                            </div>
                        </div>

                        <div className="col-12 mb-2">
                            <label>Template de Email:</label>

                            <UnForm.Select
                                className={`form-control placeholder-dark-50 `}
                                name=""
                                disabled={
                                    watcher.ID_USUARIO === ""
                                        ? true
                                        : watcher.ID_REMETENTE === ""
                                        ? true
                                        : watcher.DS_DESTINATARIO === ""
                                        ? true
                                        : false
                                }
                                onChange={(e) => {
                                    const idTemplateEmail = Number.parseInt(
                                        e.target.value
                                    );
                                    if (e && idTemplateEmail) {
                                        const docTemplate =
                                            LstDocumentoTemplate?.find(
                                                (dt) =>
                                                    dt.ID_DOCUMENTO_TEMPLATE ===
                                                    idTemplateEmail
                                            );
                                        if (
                                            docTemplate &&
                                            docTemplate.DS_ASSUNTO
                                        )
                                            setValue(
                                                "assunto",
                                                docTemplate.DS_ASSUNTO
                                            );
                                        setConvertedText({
                                            editorHtml: "Carregando....",
                                        });
                                        PreencherTemplateEmailClienteController(
                                            idTemplateEmail,
                                            {
                                                ...watcher,
                                                ID_USUARIO: watcher.ID_USUARIO,
                                                ID_CASO: ID_CASO,
                                            }
                                        )
                                            .then((res) => {
                                                setConvertedText({
                                                    editorHtml: res,
                                                });
                                            })
                                            .catch(() => {
                                                setConvertedText({
                                                    editorHtml:
                                                        "Erro ao carregar template.",
                                                });
                                            });
                                    }
                                }}
                            >
                                <option>Modelo de email</option>
                                {LstDocumentoTemplate &&
                                    LstDocumentoTemplate.map((doc) => {
                                        return (
                                            <option
                                                key={doc.ID_DOCUMENTO_TEMPLATE}
                                                value={
                                                    doc.ID_DOCUMENTO_TEMPLATE
                                                }
                                            >
                                                {doc.DS_DOCUMENTO}
                                            </option>
                                        );
                                    })}
                            </UnForm.Select>
                        </div>
                        <div className="col-12 mb-2">
                            <UnForm.Input
                                type="text"
                                name="DS_ASSUNTO"
                                autoComplete="off"
                                label="Assunto"
                                defaultValue={
                                    Atendimento?.DS_CATEGORIA_ATENDIMENTO
                                }
                                className={`form-control px-0 p-2 placeholder-muted-75`}
                                registerOptions={{
                                    required: "Insira o Assunto do E-mail",
                                }}
                            />
                        </div>
                        <div className="col-md-12 mb-2">
                            <div className=" w-100 h-100">
                                <label>Descrição:</label>
                                <FroalaEditor
                                    onChange={(e) => {
                                        handleChange(e);
                                    }}
                                    value={convertedText.editorHtml || ""}
                                />
                            </div>
                        </div>

                        <UnForm.SubmitButton
                            color="success"
                            loadingSize="sm"
                            icon={faPaperPlane}
                            loading={
                                EnviarEmailLoading ||
                                PreencherLinkEmailAgendamentoClienteVistoriaLoading
                            }
                            disabled={EnviarEmailLoading}
                            className="col-12 mt-2"
                        >
                            Enviar por email
                        </UnForm.SubmitButton>
                    </>
                )}
            </UnForm>
        </FormProvider>
    );
}
